import {
    RESET_DATA,

    GET_EARNINGS_DATA,
    GET_EARNINGS_DATA_SUCCESS,
    GET_EARNINGS_DATA_FAILED,

    GET_EARNINGS_CSV,
    GET_EARNINGS_CSV_SUCCESS,
    GET_EARNINGS_CSV_FAILED,

    SHOW_ALERT_EARNINGS,
    HIDE_ALERT_EARNINGS
} from '../actions';

// import { earningsMapping } from "../../common";

export const initialState = {
    earningsObj: {
        //loading:false,
        loading:{
            jiophone:false,
            device:false,
            Activation:false,
            Recharge:false
        },
        error: {
            jiophone:null,
            device:null,
            Activation:null,
            Recharge:null
        },
        data: {}
    },
    earningsCSVObj: {
        loading: {
            "CUT_N_PAY": false,
            "Recharge Incentive": false,
            "SCHEME PAYOUT": false,
            "Margin": false,
            "Sim Activation Payout": false,
        },
        error: null,
        data: []
    },
    showAlert: false
};


export function earningReducer(state = initialState, action) {
    switch (action.type) {
        case SHOW_ALERT_EARNINGS: {
            return {
                ...state,
                showAlert: true
            }
        }
        case HIDE_ALERT_EARNINGS: {
            return {
                ...state,
                showAlert: false
            }
        }
        case RESET_DATA:
            return {
                ...state,
                earningsObj: {
                    //loading:false,
                    loading:{
                        jiophone:false,
                        device:false,
                        Activation:false,
                        Recharge:false
                    },
                    error: {
                        jiophone:null,
                        device:null,
                        Activation:null,
                        Recharge:null
                    },
                    data: {}
                }
            }
        case GET_EARNINGS_DATA:
            // const loadingData = state.earningsObj.loading;
            // loadingData[action.tab]=true;
            return {
                ...state,
                earningsObj: {
                    loading: {
                        ...state.earningsObj.loading,
                        [action.tab]:true
                    },
                    error: {
                        ...state.earningsObj.error
                    },
                    data:state.earningsObj.data,
                }
            }

        case GET_EARNINGS_DATA_SUCCESS:
            let updatedObj = JSON.parse(JSON.stringify(state.earningsObj.data));
            updatedObj[action.params.url] = action.payload.content;
            //oadingData[action.tab]=false;
            return {
                ...state,
                earningsObj: {
                    loading: {
                        ...state.earningsObj.loading,
                        [action.tab]:false
                    },
                    error: {
                        ...state.earningsObj.error ,
                        [action.tab]:null
                    },
                    data: Object.assign(state.earningsObj.data,updatedObj)
                }
            }

        case GET_EARNINGS_DATA_FAILED:
            //loadingData[action.tab]=true;
            return {
                ...state,
                earningsObj: {
                    loading: {
                        ...state.earningsObj.loading,
                        [action.tab]:false
                    },
                    error: {
                        ...state.earningsObj.error ,
                        [action.tab]:action.error
                    },
                    data:state.earningsObj.data
                }
            }

        case GET_EARNINGS_CSV:
            return {
                ...state,
                earningsCSVObj: {
                    loading: {
                        ...state.earningsCSVObj.loading,
                        [action.tab]:true
                    },
                    error: null,
                    data: []
                }
            }

        case GET_EARNINGS_CSV_SUCCESS:
            return {
                ...state,
                earningsCSVObj: {
                    loading: {
                        ...state.earningsCSVObj.loading,
                        [action.tab]:false
                    },
                    error: null,
                    data: action.payload
                }
            }

        case GET_EARNINGS_CSV_FAILED:
            return {
                ...state,
                earningsCSVObj: {
                    loading: {
                        ...state.earningsCSVObj.loading,
                        [action.tab]:false
                    },
                    error: action.error,
                    data: []
                }
            }


        default:
            return state;
    }
}

export default earningReducer